// extracted by mini-css-extract-plugin
module.exports = {"foc":"foc__3ExgK","foc__sample":"foc__sample__oNJVb","foc__picker":"foc__picker__9wlLF"};